interface LinkChainIconProps {
    color?: string;
    width?: number;
    height?: number;
    className?: string;
}

const LinkChainIcon = ({
    color = 'currentColor',
    width = 16,
    height = 16,
    className
}: LinkChainIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        className={className}
    >
        <g clipPath="url(#clip0_37765_5025)">
            <path
                d="M10.3916 15.0876L6.86913 18.6101C6.24609 19.2328 5.40126 19.5826 4.52038 19.5826C3.6395 19.5826 2.79467 19.2328 2.17163 18.6101L1.38913 17.8276C0.766517 17.2048 0.416748 16.3603 0.416748 15.4797C0.416748 14.5991 0.766517 13.7545 1.38913 13.1318L6.47746 8.04259C7.1005 7.41988 7.94533 7.07007 8.82621 7.07007C9.7071 7.07007 10.5519 7.41988 11.175 8.04259L11.9575 8.82593"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.60831 4.9109L13.1308 1.38923C13.4392 1.08069 13.8054 0.83594 14.2084 0.668952C14.6114 0.501965 15.0433 0.416016 15.4796 0.416016C15.9158 0.416016 16.3478 0.501965 16.7508 0.668952C17.1538 0.83594 17.5199 1.08069 17.8283 1.38923L18.6108 2.1709C19.2334 2.79365 19.5832 3.63821 19.5832 4.51882C19.5832 5.39942 19.2334 6.24398 18.6108 6.86673L13.5225 11.9559C13.2141 12.2644 12.8479 12.5092 12.4449 12.6762C12.0419 12.8432 11.61 12.9291 11.1737 12.9291C10.7375 12.9291 10.3055 12.8432 9.90253 12.6762C9.49953 12.5092 9.13337 12.2644 8.82498 11.9559L8.04248 11.1726"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_37765_5025">
                <rect width="20" height="20" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default LinkChainIcon;
